import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { FieldModule } from '../field/field.module';
import { TextAreaComponent } from './text-area.component';

@NgModule({
  imports: [CommonModule, FieldModule, ButtonModule],
  declarations: [TextAreaComponent],
  exports: [TextAreaComponent],
})
export class TextAreaModule {}
